// extracted by mini-css-extract-plugin
module.exports = {"n6eygn3":"n6eygn3","sub-tab":"sub-tab","active":"active","tab":"tab"};